
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useSlot } from '@/modules/slot/model/edit';
import { ROUTE_NAME_SLOT } from '@/modules/slot/router';

export default defineComponent({
    name: ROUTE_NAME_SLOT,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useSlot();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
